import { Controller } from '@hotwired/stimulus'

// Clears and locks sub-fields (value inputs, dates) when the Yn select is not 'Y'.
// On initial connect: locks without clearing (preserves existing values for display).
// On user toggle to 'N': clears and locks. On toggle to 'Y': unlocks.
export default class extends Controller {
  static targets = ['yn', 'subfield']

  connect() {
    this.applyState(false)
  }

  toggle() {
    this.applyState(true)
  }

  applyState(shouldClear) {
    const isYes = this.ynTarget.value === 'Y'
    this.subfieldTargets.forEach(field => {
      if (!isYes && shouldClear) field.value = ''
      field.disabled = !isYes;
      ['opacity-50', 'bg-gray-100', 'cursor-not-allowed'].forEach(cls =>
        field.classList.toggle(cls, !isYes)
      )
    })
  }
}
